// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/wand-sparkles.js';

import { paths } from '../generated/wand-sparkles';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('wand-sparkles', Original, paths);
